(() => {
  if (window.mjLinkedProtectionLoaded) return;
  window.mjLinkedProtectionLoaded = true;
  const config = JSON.parse(document.getElementById('mj-linked-protection-config').textContent);
  const root = config.root.replace(/\/?$/, '/');
  const protectionId = 55898101350742;
  const holderId = 55897803424086;
  const excluded = new Set([protectionId, 55920572105046, 55920566305110, 55920568205654]);
  let busy = false;
  let cleanupFailed = false;
  let ready;
  const request = async (path, body) => {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET', credentials:'same-origin',
      headers:{Accept:'application/json', ...(body ? {'Content-Type':'application/json'} : {})},
      ...(body ? {body:JSON.stringify(body)} : {})
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(config.error);
    return data;
  };
  const parents = cart => cart.items.filter(item => item.requires_shipping && !item.parent_relationship && !excluded.has(item.variant_id));
  const protection = cart => cart.items.filter(item => item.variant_id === protectionId);
  const lock = value => document.documentElement.classList.toggle('mj-protection-pending', value);
  const refreshCart = async () => {
    const mainItems = document.getElementById('main-cart-items');
    const mainFooter = document.getElementById('main-cart-footer');
    const drawer = document.querySelector('cart-drawer');
    const sections = ['cart-icon-bubble'];
    if (drawer) sections.push('cart-drawer');
    if (mainItems) sections.push(mainItems.dataset.id);
    if (mainFooter) sections.push(mainFooter.dataset.id);
    const cart = await request('cart/update.js', {updates:{}, sections, sections_url:window.location.pathname});
    const parsed = {};
    for (const section of sections) {
      if (!cart.sections?.[section]) throw new Error(config.error);
      parsed[section] = new DOMParser().parseFromString(cart.sections[section], 'text/html');
    }
    const focusId = document.activeElement?.id;
    const scrollY = window.scrollY;
    const body = drawer?.querySelector('.cart-drawer__body');
    const bodyScroll = body?.scrollTop || 0;
    const copy = (target, source) => { if (target && source) target.innerHTML = source.innerHTML; };
    if (drawer) {
      const fresh = parsed['cart-drawer'];
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      if (cart.item_count === 0) {
        copy(drawer.querySelector('.drawer__inner'), fresh.querySelector('.drawer__inner'));
      } else {
        for (const selector of ['#CartDrawer-CartItems', '.drawer__heading', '.cart-drawer__totals']) {
          copy(drawer.querySelector(selector), fresh.querySelector(selector));
        }
        drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
        const oldCard = drawer.querySelector('mj-cart-protection');
        const newCard = fresh.querySelector('mj-cart-protection');
        if (oldCard && newCard) oldCard.replaceWith(newCard);
        else if (oldCard) oldCard.remove();
        else if (newCard) drawer.querySelector('.drawer__footer')?.prepend(newCard);
      }
    }
    if (mainItems) {
      copy(mainItems.querySelector('.js-contents'), parsed[mainItems.dataset.id].querySelector('.js-contents'));
      mainItems.closest('cart-items')?.classList.toggle('is-empty', cart.item_count === 0);
    }
    if (mainFooter) {
      copy(mainFooter.querySelector('.js-contents'), parsed[mainFooter.dataset.id].querySelector('.js-contents'));
      mainFooter.classList.toggle('is-empty', cart.item_count === 0);
      const checkout = mainFooter.querySelector('[name="checkout"]');
      if (checkout) checkout.disabled = cart.item_count === 0;
    }
    copy(document.getElementById('cart-icon-bubble'), parsed['cart-icon-bubble'].querySelector('.shopify-section'));
    if (body) body.scrollTop = bodyScroll;
    if (focusId) document.getElementById(focusId)?.focus({preventScroll:true});
    window.scrollTo({top:scrollY, behavior:'instant'});
    return cart;
  };
  const removeProtection = async cart => {
    const updates = Object.fromEntries(protection(cart).map(item => [item.key, 0]));
    if (Object.keys(updates).length) return request('cart/update.js', {updates});
    return cart;
  };
  const cleanLegacyProtection = async () => {
    if (!config.present) { lock(false); return; }
    const cart = await request('cart.js');
    const parentKeys = new Set(parents(cart).map(item => item.key));
    const updates = {};
    let kept = false;
    for (const item of protection(cart)) {
      if (!item.parent_relationship || !parentKeys.has(item.parent_relationship.parent_key) || kept) {
        updates[item.key] = 0;
      } else {
        kept = true;
        if (item.quantity !== 1) updates[item.key] = 1;
      }
    }
    if (Object.keys(updates).length) {
      await request('cart/update.js', {updates});
      await refreshCart();
    }
    lock(false);
  };
  document.addEventListener('click', event => {
    if (document.documentElement.classList.contains('mj-protection-pending') && event.target.closest('[name="checkout"], a[href*="/checkout"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (document.documentElement.classList.contains('mj-protection-pending') && (event.submitter?.name === 'checkout' || event.target.id === 'cart')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  customElements.define('mj-cart-protection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('input').addEventListener('change', event => this.update(event));
    }
    async update(event) {
      if (busy) return;
      const input = event.target;
      const wanted = input.checked;
      const error = this.querySelector('[role="alert"]');
      busy = true;
      input.disabled = true;
      error.hidden = true;
      lock(true);
      this.setAttribute('aria-busy', 'true');
      try {
        await ready;
        lock(true);
        let cart = await request('cart.js');
        if (!wanted) {
          await removeProtection(cart);
        } else {
          const eligible = parents(cart);
          if (!eligible.length) throw new Error(config.error);
          const existing = protection(cart);
          const alreadyLinked = existing.length === 1 && existing[0].quantity === 1 && eligible.some(parent => parent.key === existing[0].parent_relationship?.parent_key);
          if (!alreadyLinked) {
            await removeProtection(cart);
            cart = await request('cart.js');
            const currentParents = parents(cart);
            const parent = currentParents.find(item => item.variant_id === holderId) || currentParents[0];
            if (!parent) throw new Error(config.error);
            await request('cart/add.js', {items:[{id:protectionId, quantity:1, parent_line_key:parent.key}]});
          }
        }
        await refreshCart();
        busy = false;
        lock(false);
      } catch (_) {
        busy = false;
        input.checked = !wanted;
        input.disabled = false;
        this.removeAttribute('aria-busy');
        lock(cleanupFailed);
        error.textContent = config.error;
        error.hidden = false;
      }
    }
  });
  ready = cleanLegacyProtection().catch(() => {
    cleanupFailed = true;
    lock(true);
    const error = document.createElement('p');
    error.setAttribute('role', 'alert');
    error.style.cssText = 'padding:16px;color:#bd0d2f;text-align:center';
    error.textContent = config.error;
    document.querySelector('#main-cart-footer, cart-drawer .drawer__footer, main')?.prepend(error);
    throw new Error(config.error);
  });
  ready.catch(() => {});
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      lock(true);
      refreshCart().then(() => lock(false)).catch(() => lock(true));
    }
  });
})();
